<div class="service-details-chart">
    <loader [size]="'medium'" *ngIf="displayLoader"></loader>
    <div #chartContainer></div>
</div>
